import { Rule } from 'antd/es/form'

export interface IFormData {
  _id: string
  name?: string
  status?: string
  parentId?: string
}

export interface IFormRule {
  name?: Rule[]
  status?: Rule[]
}

export const initValues: IFormData = {
  _id: '',
  name: '',
  status: '',
}

export enum StatusItemCategoryEnum {
  active = 'active',
  // error = 'error',
  inactive = 'inactive',
  deleted = 'deleted',
}

export type StatusItemCategoryType = keyof typeof StatusItemCategoryEnum

export interface IPropsUpdateItemCategory {
  fetchTable: () => void
  id?: string | number
}
